import React from 'react'
import Moment from 'react-moment'
export default function Timestamp(props) {
  return <Moment format="HH:mm:ss">{props.children}</Moment>
}
